import React, { useRef, useState } from 'react';
import './ImageUploader.css';

const ImageUploader = ({ previewUrl, onFileSelect, onRemoveImage }) => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  
  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };
  
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };
  
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    
    const dt = e.dataTransfer;
    const files = dt.files;
    
    if (files.length > 0) {
      handleFiles(files);
    }
  };
  
  const handleFiles = (files) => {
    if (files.length > 0) {
      const file = files[0];
      // 检查文件类型是否为图片
      if (!file.type.match('image.*')) {
        alert('请选择图片文件！');
        return;
      }
      onFileSelect(file);
    }
  };
  
  const handleFileInputChange = (e) => {
    handleFiles(e.target.files);
  };
  
  const handleRemoveClick = () => {
    onRemoveImage();
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
  
  return (
    <div className="image-uploader">
      <h3>上传图片</h3>
      
      {!previewUrl ? (
        <div 
          className={`drop-area ${isDragging ? 'highlight' : ''}`}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          <input 
            type="file" 
            id="file-input" 
            accept="image/*" 
            onChange={handleFileInputChange}
            ref={fileInputRef}
            style={{ display: 'none' }}
          />
          <label htmlFor="file-input" className="file-label">
            <div className="upload-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48">
                <path d="M12 16l4-5h-3V4h-2v7H8l4 5z"></path>
                <path d="M20 18H4v-7H2v7c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-7h-2v7z"></path>
              </svg>
            </div>
            <span>点击或拖放图片到此处</span>
          </label>
        </div>
      ) : (
        <div className="preview-container">
          <img src={previewUrl} alt="预览图" className="preview-image" />
          <button className="remove-image-btn" onClick={handleRemoveClick}>删除</button>
        </div>
      )}
    </div>
  );
};

export default ImageUploader; 